import { STACK } from "@/data/content";

export default function Marquee() {
  const row = [...STACK, ...STACK];
  return (
    <div className="relative border-y border-white/5 bg-navy-900/40 py-5 overflow-hidden" data-testid="tech-stack-marquee">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((tech, i) => (
          <span key={`${tech}-${i}`} className="flex items-center gap-10">
            <span className="font-mono text-sm uppercase tracking-[0.2em] text-slate-500">{tech}</span>
            <span className="h-1 w-1 rounded-full bg-cyan-400/60" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
}
